import { Link, useLocation } from "react-router-dom";

const tabs = [
  { label: "首页", icon: "ri-home-5-line", to: "/" },
  { label: "分类", icon: "ri-layout-grid-line", to: "/category/all" },
  { label: "更新", icon: "ri-flashlight-line", to: "/updates" },
  { label: "搜索", icon: "ri-search-line", to: "/search" },
  { label: "关于", icon: "ri-user-smile-line", to: "/about" },
];

export default function MobileTabBar() {
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-background-200 bg-background-50/95 backdrop-blur md:hidden">
      <div className="grid grid-cols-5">
        {tabs.map((tab) => {
          const active =
            tab.to === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(tab.to.split("?")[0]);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={`flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors ${
                active ? "text-primary-600" : "text-foreground-500"
              }`}
            >
              <span
                className={`flex h-8 w-8 items-center justify-center rounded-md ${
                  active ? "bg-primary-100 text-primary-700" : "text-foreground-500"
                }`}
              >
                <i className={`${tab.icon} text-lg`}></i>
              </span>
              {tab.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}